export default "__VITE_PUBLIC_ASSET__307310e1__"